module.exports = __webpack_public_path__ + "static/media/successBell.056c0a80.ogg";